module.exports = ".recupera_senha {\r\n    text-align: center;\r\n    cursor: pointer;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/login.component.css
// module id = ./src/app/pages/login/login.component.css
// module chunks = main